import { Component, OnInit, Input, EventEmitter,  } from '@angular/core';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit {
  form: FormGroup;
  email: string;
  name: string;
  message: string;  
  successMsg: any;
  failMsg: any;
   
  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      name: ['', Validators.required],
      message: ['', Validators.required]
    });
  }
  
  ngOnInit() {}

  sendMail(value) {      
    const data = {
        to: 'd102791estiny@gmail.com',
        subject: this.name,
        txt:  'Email:' + this.email + 
              'Name:' + this.name + 
              'Message:' + this.message
    };

    return this.http.post('http://localhost:3000/api/mail/contact', data,
    { headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'text' }).subscribe(
      data => {
        this.successMsg = true;
        console.log('Your Message has been sent!');
        this.form.reset();
      }, error => {
        this.failMsg = true;
        console.log('Failed!');
        this.form.reset();
      }     
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/contact/contact.component.ts